import React, { Component } from 'react';
import Formulario from './FaltaForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

class Falta extends Component{
    state = {
        crear: true,
    }

    componentDidMount = () => {
        const { match, getModulo, listarColaborador, leer,
        limpiarDatos, leerPeriodoD, parametrosEmpresa } = this.props;
        const id = match.params.id;
        if (id){
            this.setState({crear: false});
            leer(id);
        }
        let ruta = window.location.href;
        let modulo = ruta.split('/');
        
        getModulo(modulo[5],modulo[4]);
        listarColaborador();
        limpiarDatos();
        leerPeriodoD(modulo[5], modulo[7]);
        parametrosEmpresa();
    }
    
    render(){
        const { loader, modulo, emp, registroFalta, tipo,
            datosColaborador, cargo, lectura, modificarFalta,
            periodoD, datos } = this.props;
        const { crear } = this.state;
        return(
            <LoadMask loading={loader} dark>
                <Formulario
                    crear = {crear}
                    modulo = {modulo}
                    emp = {emp}
                    registroFalta = {registroFalta}
                    cargo = {cargo}
                    tipo = {tipo}
                    datosColaborador = {datosColaborador}
                    lectura = {lectura}
                    modificarFalta = {modificarFalta}
                    periodo={periodoD}
                    datos = {datos}
                />
            </LoadMask>
        );
    }
}

export default Falta;